/**
 * Calculates age in years from a date-of-birth string (YYYY-MM-DD).
 *
 * Returns NaN when the string does not parse to a valid calendar date.
 */
export function calculateAge(dateOfBirth: string): number {
  const birthDate = new Date(dateOfBirth);
  if (Number.isNaN(birthDate.getTime())) return Number.NaN;
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
}

/**
 * Returns true if the person is eligible for Sollis Pediatrics (age under 18).
 *
 * Invalid, missing, or future dates of birth are treated as ineligible so
 * account-level pediatrics availability alone never unlocks upgrades for adults.
 */
export function isPediatricsEligible(
  dateOfBirth: string | undefined | null
): boolean {
  const trimmed = dateOfBirth?.trim() ?? '';
  if (!trimmed) return false;
  const age = calculateAge(trimmed);
  if (!Number.isFinite(age) || age < 0) return false;
  return age < 18;
}
